module.exports = __webpack_public_path__ + "img/jiahui_20210901114517.f7f60146.png";